<script>
import Vue from 'vue'
// resources
import RuleResource from '../../resources/rule'

// components&views
import RuleGrid from '../../components/rule_grid/RuleGrid'
import RuleGroupGrid from '../../components/rule_grid/RuleGroupGrid'
import RuleCollectionGrid from '../../components/rule_grid/RuleCollectionGrid'

// mixins
import toastMixin from '../../mixins/toast'
import modalMixin from '../../mixins/modal'
import { ruleFormSet, ruleGroupFormSet, ruleCollectionFormSet } from '../../resources/formsets/rule'

export default Vue.extend({
    data() {
        return {
            RuleResource: null,
            selectedRuleResource: null,
            ruleIteration: 0,
            ruleGroupIteration: 1000,
            ruleCollectionIteration: 10000,
        }
    },
    mixins: [toastMixin, modalMixin],
    components: {
        RuleGrid,
        RuleGroupGrid,
        RuleCollectionGrid,
    },
    computed: {
        resources() {
            return {
                RuleResource,
            }
        },
        formsets() {
            return {
                ruleFormSet,
                ruleGroupFormSet,
                ruleCollectionFormSet,
            }
        },
    },
    methods: {
        selectRule(selectedResource) {
            if (selectedResource && selectedResource.id) this.selectedRuleResource = selectedResource
        },
        selectRuleGroup(selectedResource) {
            if (selectedResource && selectedResource.id) this.selectedRuleGroupResource = selectedResource
        },
        selectRuleCollection(selectedResource) {
            if (selectedResource && selectedResource.id) this.selectedRuleCollectionResource = selectedResource
        },
    },
})
</script>

<template>
    <div class="pageStyling">
        <rule-grid :key="ruleIteration" class="ag-theme-balham agGrid" @select="selectRule" />
        <rule-group-grid :key="ruleGroupIteration" class="ag-theme-balham agGrid" @select="selectRuleGroup" />
        <rule-collection-grid :key="ruleCollectionIteration" class="ag-theme-balham agGrid" @select="selectRuleCollection" />
    </div>
</template>

<style scoped>
.pageStyling {
    margin: 50px 0px 0px 25px;
}

.autocompleteContainer {
    width: 25%;
}

.agGrid {
    margin: 50px 0px 0px 0px;
}

.buttonContainer {
    display: flex;
    margin-top: 20px;
}

.buttonContainer > * {
    margin-right: 20px;
}
</style>
